"use client";
import { cn } from "@/lib/utils";
import { useState } from "react";
import {
  ResizableHandle,
  ResizablePanel,
  ResizablePanelGroup,
} from "../ui/resizable";
import AppNav from "./AppNav";

export default function AppBody({ children }: { children: React.ReactNode }) {
  const [isCollapsed, setIsCollapsed] = useState(false);

  return (
    <ResizablePanelGroup
      direction="horizontal"
      className="grid min-h-screen w-full md:grid-cols-[220px_1fr] lg:grid-cols-[280px_1fr]"
      autoSaveId="app-nav"
    >
      <ResizablePanel
        defaultSizePixels={210}
        minSizePixels={200}
        maxSizePixels={450}
        collapsedSizePixels={50}
        collapsible={true}
        onExpand={() => setIsCollapsed(false)}
        onCollapse={() => setIsCollapsed(true)}
        className={cn(
          isCollapsed && " transition-all duration-300 ease-in-out",
          "hidden md:flex bg-muted/40",
        )}
      >
        <div className="hidden  md:block h-full w-full">
          <div className="flex h-full max-h-screen flex-col gap-2 fixed top-14 left-0 z-40">
            <div className="flex-1">
              <AppNav isCollapsed={isCollapsed} />
            </div>
          </div>
        </div>
      </ResizablePanel>
      <ResizableHandle withHandle className="hidden md:flex " />
      <ResizablePanel>
        <div className="flex flex-col pt-14 lgpt-[60px]">
          <main className="flex flex-1 flex-col gap-4 p-4 lg:gap-6 lg:p-6 items-center">
            {children}
          </main>
        </div>
      </ResizablePanel>
    </ResizablePanelGroup>
  );
}
